import {
  pageInfo,
  PerkSectionItemsV2Fragment,
  RewardsPromoSectionFragment,
  VendorItemFragment,
} from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const getPerkSectionsV2 = gql`
  query GetPerkSections(
    $input: PerkSectionsItemsV2Input
    $perkSectionsInput: PerkSectionsInput
    $perkSectionsId: ID
    $first: Int
    $after: String
    $promoSectionInput: PromoSectionInput!
  ) {
    myPartnerOffers {
      perkSections(
        perkSectionsInput: $perkSectionsInput
        id: $perkSectionsId
        first: $first
        after: $after
      ) {
        name
        edges {
          node {
            itemsV2(input: $input) {
              ... on SectionItems {
                __typename
                ...PerkSectionItemsV2Fragment
              }
              ... on VendorItem {
                __typename
                ...VendorItemFragment
              }
            }
            hasNext
            id
            name
            sectionStyleType
          }
        }
        promoSection(input: $promoSectionInput) {
          ...RewardsPromoSectionFragment
        }
        pageInfo {
          ...pageInfo
        }
      }
    }
  }
  ${PerkSectionItemsV2Fragment}
  ${pageInfo}
  ${RewardsPromoSectionFragment}
  ${VendorItemFragment}
`;

export default getPerkSectionsV2;
